import React from 'react'

const FAQ = () => {
  return (
    <>
      <div className="bg-[#171B3E] text-white h-screen px-5 md:px-20 py-4 md:py-14">
        FAQ
      </div>
    </>
  )
}

export default FAQ